import { RoleHierarchy } from '../../../shared/src/data/roleHierarchy/roleHierarchy'

export const serverRoutes = {
  api: {
    route: () => process.env.PUBLIC_URL + '/api',
    scansMetadata: {
      route: () => serverRoutes.api.route() + '/scansMetadata',
      get: (scanId: string) =>
        serverRoutes.api.scansMetadata.route() + `/${scanId}`,
      pendingScansForHierarchy: (roleHierarchy: RoleHierarchy) =>
        serverRoutes.api.scansMetadata.route() +
        `/pendingScansForHierarchy/${roleHierarchy.branch.id}`,
      scansForHierarchy: (roleHierarchy: RoleHierarchy) =>
        serverRoutes.api.scansMetadata.route() +
        `/scansForHierarchy/${roleHierarchy.branch.id}`,
      filesForScan: (uploadId: string) =>
        serverRoutes.api.scansMetadata.route() + `/filesForScan/${uploadId}`,
      getFilePreSignedUrl: (id: string) =>
        serverRoutes.api.scansMetadata.route() + `/getFilePreSignedUrl/${id}`,
    },
    check: {
      route: () => serverRoutes.api.route() + '/check',
    },
    fasttrack: {
      route: () => serverRoutes.api.route() + '/fasttrack',
      execute: () => serverRoutes.api.fasttrack.route() + `/execute`,
    },
    executions: {
      route: () => serverRoutes.api.route() + '/executions',
      pending: () => serverRoutes.api.executions.route() + `/pending`,
      queued: () => serverRoutes.api.executions.route() + `/queued`,
      finished: (lastAmount: number) =>
        serverRoutes.api.executions.route() + `/finished/${lastAmount}`,
      execution: (executionId: string) =>
        serverRoutes.api.executions.route() + `/${executionId}`,
      scanPending: (scanId: string) =>
        serverRoutes.api.executions.route() + `/${scanId}/pending`,
      startScan: (scanId: string) =>
        serverRoutes.api.executions.route() + `/${scanId}/start`,
      stopScan: (scanId: string) =>
        serverRoutes.api.executions.route() + `/${scanId}/stop`,
      runScans: () => serverRoutes.api.executions.route() + `/start`,
      stopScans: () => serverRoutes.api.executions.route() + `/stop`,
      results: (executionId: string) =>
        serverRoutes.api.executions.route() + `/${executionId}/results`,
    },
    executionParams: {
      route: () => serverRoutes.api.route() + '/executionParams',
      get: (projectId: string, scanId: string, executionHash: string) =>
        serverRoutes.api.executionParams.route() +
        `/${projectId}/${scanId}/${executionHash}`,
      post: (projectId: string, scanId: String, executionHash: string) =>
        serverRoutes.api.executionParams.route() +
        `/${projectId}/${scanId}/${executionHash}`,
    },
  },
}
